import { render, staticRenderFns } from "./TgLiveDetailPreview.vue?vue&type=template&id=031d5442&"
import script from "./TgLiveDetailPreview.vue?vue&type=script&lang=js&"
export * from "./TgLiveDetailPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports